import React from 'react';
import { Button, Grid } from '@mui/material';
import { StakeInput } from './inputs/StakeInput';
import { ClaimInput } from './inputs/ClaimInput';
import { useStakingContext } from '../contexts/staking.context';
import OZKLogo from '../../../Assets/images/Icons/OZKTokenIcon.png';
import { CheckIn } from './inputs/CheckIn';

export const VaultDetails = ({ vault }) => {
  return (
    <Grid
      container
      display="flex"
      justifyContent={'flex-start'}
      alignItems="center"
      sx={{ pt: 1, gap: { md: '16px', xs: '16px' } }}
    >
      <Grid
        item
        lg={1.8}
        md={12}
        sm={12}
        xs={12}
        display="flex"
        flexDirection="column"
        justifyContent="center"
        gap="4px"
      >
        <Grid
          display="flex"
          className="text-white font-poppins text-base leading-6"
          lg={0}
          md={12}
          sx={{ display: { xs: 'flex', md: 'none' } }}
        >
          <p className="font-normal">OZK Staked</p>
          <p className="font-bold flex">
            {' '}
            {`: ${vault.ozkStaked} OZK`}
            <img
              src={OZKLogo}
              alt={'OZK LOGO'}
              width={'18px'}
              height={'18px'}
              className="ml-1 my-1"
            />
          </p>
        </Grid>
        <Grid
          display="flex"
          className="text-white font-poppins text-base leading-6"
        >
          <p className="font-normal">APR</p>
          <p className="font-bold"> {`: ${vault.apr}%`}</p>
        </Grid>
        <Grid
          display="flex"
          className="text-white font-poppins text-base leading-6"
        >
          <p className="font-normal">Ends in</p>
          <p className="font-bold">{`: ${vault.endsIn}`}</p>
        </Grid>
      </Grid>
      <ClaimInput vault={vault} />
      <CheckIn vault={vault} />
      <StakeInput vault={vault} />
    </Grid>
  );
};
